export const AnalyticsColor = {
    green: "#82ca9d",
    purple: "#8884d8",
    blue: "#4454e9"
};
